module.exports = __webpack_public_path__ + "img/UY.947b20c7.svg";